/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateDeliveryNoteResponse } from '../../models/create-delivery-note-response';
import { KeyType } from '../../models/key-type';
import { PostDeliveryNoteRequest } from '../../models/post-delivery-note-request';

export interface PostDeliveryNoteToPool$Params {
  organizationSiteKey: KeyType;
      body: PostDeliveryNoteRequest
}

export function postDeliveryNoteToPool(http: HttpClient, rootUrl: string, params: PostDeliveryNoteToPool$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateDeliveryNoteResponse>> {
  const rb = new RequestBuilder(rootUrl, postDeliveryNoteToPool.PATH, 'post');
  if (params) {
    rb.path('organizationSiteKey', params.organizationSiteKey, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CreateDeliveryNoteResponse>;
    })
  );
}

postDeliveryNoteToPool.PATH = '/organization-sites/{organizationSiteKey}/consignor/delivery-notes';
